/**
 * The vouch predicate for a stored assistant room record -- the pure decision the device cache
 * (`utils/assistant/assistant-room-cache.ts`) reads through, held here as that leaf's `max-lines` split: a `utils/`
 * leaf may value-import a `const/` decision but never a `utils/` sibling (`QUAL-NO-RUNTIME-IMPORTS-IN-UTILS-001`).
 */

import { DEFAULT_CONVERSATION_TYPE } from './assistant.ts';
import { isRecordValue } from './record-guards.ts';
import type { CachedAssistantRoom } from '@federa/types/assistant-room-cache';

/** Stop presenting a ticket this long before the server's own expiry, so a socket never dials on a ticket about to lapse. */
export const ROOM_TICKET_CLIENT_MARGIN_SEC = 30;

/** A record the cache will vouch for: the viewer's, carrying an id, and an ASSISTANT conversation.
 *  @runtime-derived-ssot-helper (const-leaf-pinned): its consumer is the utils/ assistant room cache, which may not
 *  value-import a utils/ sibling. */
export function isCachedAssistantRoom(value: unknown, userId: string): value is CachedAssistantRoom {
	if (!isRecordValue(value) || value.userId !== userId) return false;
	const room = value.room;
	return isRecordValue(room) && typeof room.id === 'string' && room.id !== '' && room.conversationType === DEFAULT_CONVERSATION_TYPE;
}
